<template>
  <div class="modal fade" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true"/>
          <h4 class="modal-title">GROUPS</h4>
        </div>
        <div class="modal-body">
          <div class="col-md-12">
            <div class="row">
              <div class="form-group" v-for="(column, key) in columns" :key="key">
                <label class="control-label">Column {{ key }}</label>
                <select class="form-control" @change="updateColumn(key, $event)">
                  <option :value="undefined"></option>
                  <option :value="optionKey" v-for="(option, optionKey) in options" :selected="column.label == option.label">{{ option.label }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="modal-footer">
          <button class="btn green" @click.prevent="confirmed()" data-dismiss="modal">Save</button>
          <button class="btn default" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {HTTP} from '@/http-common';

  export default {
    props: {
      context : {
        type: String,
        default: 'groups_forms'
      }
    },
    data() {
      return {
        options: [],
        columns: []
      }
    },
    methods: {
      confirmed() {
        this.$emit('confirmed', this.columns);
      },
      loadOptions() {
        HTTP.get(`participant-directory-columns/list`, {params: {context: this.context}})
          .then(response => {
            this.options = response.data.data.columns;
          }).catch(err => {
          console.log(err);
        });
      },
      loadColumns() {
        HTTP.get(`participant-directory-columns/columns`, {params: {context: this.context}})
          .then(response => {
            this.columns = response.data.data.columns;
          }).catch(err => {
          console.log(err);
        });
      },
      updateColumn(columnKey, event) {
        let option = this.options[event.target.value];

        let label = '';
        let field = '';

        if (option) {
          label = option['label'];
          field = option['field'];
        }

        this.columns[columnKey]['label'] = label;
        this.columns[columnKey]['field'] = field;

        if (option['key'] !== undefined) {
          this.columns[columnKey]['key'] = option['key'];
        }
      }
    },
    mounted() {
      this.loadOptions();
      this.loadColumns();
    }
  }
</script>



// WEBPACK FOOTER //
// GroupsFormsColumns.vue?155c6ab5